import loadable from '@loadable/component'
const LoadableComponent = loadable(() => import('./hikakuTableGPU'))
export default function Component(props) {
  return (
    <LoadableComponent {...props}/>
  )
}